// extracted by mini-css-extract-plugin
export var colorSquare = "_og-0";
export var danger = "_og-5";
export var lightPink = "_og-8";
export var neutralBlue = "_og-7";
export var neutralYellow = "_og-6";
export var normal = "_og-1";
export var primary = "_og-2";
export var primaryLight = "_og-3";
export var solidBlack = "_og-g";
export var solidGreen = "_og-b";
export var solidLightBlue = "_og-d";
export var solidNavy = "_og-c";
export var solidOrange = "_og-f";
export var solidPink = "_og-e";
export var solidRed = "_og-9";
export var solidYellow = "_og-a";
export var success = "_og-4";